export default class Organization {
  id: string;
  name: string;
  processingAuction?: string;
  stateId?:string;
  accessGroups?: Array<UserInfoContextAccessGroupRoles>;
  auctionAccessId?: string;
  buyerCluster90Day?: string;
  buyerCluster365Day?: string;
  paymentMethods?: Array<number>;
  restrictionGroups?: Array<number>;
}

export interface NWAccessUserIdAndToken {
    accessToken?: string;
    accessUserId?: string;
}

export interface UserInfoContextAccessGroupRoles {
    accessGroupId?: string;
    roles?: Array<number>;
}
